import React from 'react';

import colors from 'config/colors';

import Button from './Button';

const BackButton = () => (
  <Button
    shape="circle"
    size="large"
    icon={{
      name: "arrow-left",
      color: colors.grey.lightDark,
      size: 18
    }} />
);

export default BackButton;
